module.exports = __webpack_public_path__ + "static/media/mern-fb.0939a9dc.png";